import Swal from "sweetalert2";

const deleteAlert = (open, id, handleApi, getApi) => {
  if (open) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleApi(id)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: res.data.message,
              confirmButtonColor: "#ff3600",
            });
            getApi();
          })
          .catch((err) => {
            console.error(err, "ererererere");
          });
      }
    });
  }
};

 const resendConfirm = ({
  title = "Are you sure?",
  text = "This action cannot be undone.",
  confirmText = "Yes, resend",
  onConfirm,
}) => {
  Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: confirmText,
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};



export { deleteAlert, resendConfirm };
